<template>
  <div>
    <Modal :id="modalId" title="Delete item" ref="modal" @close="closeModal()">
      <div class="modal-body text-center">
        <slot name="default" v-if="state === 'WAITING'">
          <h5 class="text-justify">
            Are you sure you want to delete <br />
            <span class="item-title">{{ itemTitle }}</span
            >?
            <br />
            <br />
          </h5>
          <span>This action cannot be undone.</span>
        </slot>
        <slot name="default" v-if="state === 'DONE'">
          <h5 class="text-justify" v-html="deleteStatus" data-cy="deleteItem-notice"></h5>
        </slot>
      </div>
      <LoadingSpinner position="absolute" v-if="state === 'REQUESTING'" />
      <!-- Yes and No Buttons -->
      <div class="text-center decision-buttons">
        <slot name="footer">
          <SButtonMaterial
            class="delete-item-btn mr-4"
            buttonType="button"
            color="danger"
            textColor="white"
            materialClass="dense"
            text="Delete"
            @button="tryToDeleteItem()"
            v-if="state === 'WAITING'"
            data-cy="confirmDeleteItem-btn"
          />
          <SButtonMaterial
            class="cancel-item-btn"
            buttonType="button"
            color="primary"
            textColor="white"
            materialClass="dense"
            :text="getActionText"
            @button="closeModal()"
            v-if="state === 'DONE' || 'ERROR'"
          />
        </slot>
      </div>
    </Modal>
  </div>
</template>
<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import Modal from "@/components/atoms/Modal.vue";
import LoadingSpinner from "@/material-components/atoms/LoadingSpinner.vue";
import requestSituation from "@/enum/request-situation";
import itemType from "@/enum/item-type";
export default {
  name: "ModalDeleteItem",
  props: ["item", "itemHaveRequests"],
  mixins: [UserHelperVue, ItemHelperVue],
  data() {
    return {
      state: "WAITING",
      deleteStatus: "",
      itemTitle: this.item.title,
      itemId: this.item.id,
      reqSituation: requestSituation,
      iType: itemType,
      declineNotification: "",
    };
  },
  components: {
    SButtonMaterial,
    Modal,
    LoadingSpinner,
  },
  computed: {
    modalId() {
      return `delete-item-${this.itemId}`;
    },
    getActionText() {
      if (this.state === "WAITING") return "Cancel";
      return "Close";
    },
  },
  methods: {
    closeModal() {
      this.$refs.modal.closeModal();
      if (this.deleteStatus) {
        this.$emit("deleteItem");
      }
    },
    async tryToDeleteItem() {
      if (this.isUserAuthenticated) {
        this.state = "REQUESTING";
        if (this.itemHaveRequests) {
          this.sendRejectEveryRequest();
        }
        const result = await this.deleteItem(this.itemId);
        if (result.result === "Item deleted!") {
          this.deleteStatus = `You have deleted <strong>${this.itemTitle}</strong> successfully.`;
          this.state = "DONE";
        } else {
          this.deleteStatus = result.error;
          this.state = "ERROR";
        }
      }
    },
    sendRejectEveryRequest() {
      this.item.requests.forEach((request) => {
        if (request.situation === this.reqSituation.OPEN) {
          try {
            this.sendDeclineMessage(request, this.item);
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    async sendDeclineMessage(itemRequest, item) {
      this.setNotification(item);
      try {
        await this.postUserItemMessage({
          partner: itemRequest.sUserId,
          item: item.id,
          postMsg: this.declineNotification,
          newChat: true,
        });
      } catch (error) {
        console.log(error);
      }
    },
    setNotification(item) {
      let type = item.type;
      if (type === this.iType.GIVE || type === this.iType.LEND) {
        this.declineNotification = `Hi, I didn't accept your request for the item ${item.title}`;
      } else if (type === this.iType.RECEIVE || type === this.iType.BORROW) {
        this.declineNotification = `Hi, I didn't accept your offer for the item ${item.title}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.decision-buttons {
  margin-top: 4rem;
}
.text-center {
  text-align-last: center;
}
.text-justify {
  margin-top: 2rem;
  font-weight: normal;
  word-break: break-all;
}
.item-title {
  font-weight: bold !important;
  word-break: break-all;
}
.item-title,
.text-justify {
  color: $black !important;
}
</style>
